import styled from 'styled-components'
import tw from 'twin.macro'

export const Root = styled.div`
  ${tw`grid gap-x-4 sm:gap-x-8 items-start`};
  grid-template-columns: auto 1fr;
`

export const ImageWrapper = styled.div`
  ${tw`border-2 box-content`};
  border-color: var(--color-gold-white);

  img,
  svg {
    ${tw`w-24 sm:w-36 h-24 sm:h-36`}
  }

  img {
    background-color: var(--color-gold-white);
  }
`

export const Meta = styled.div`
  ${tw`text-left`};

  th {
    ${tw`pr-4`};
  }
`

export const OriginalQuantity = styled.span`
  color: var(--color-danger);
`
